/*
 * Selettore colonne delle griglie.
 * Markup: snippets/andpow-colsSwitch.liquid. Stile: assets/andpow-cols-switch.css.
 *
 * La scelta vale per la pagina in cui l'utente la fa: localStorage, chiave
 * "andpow-cols:" + percorso, valore tipo {"d":3,"m":1}. Lo script nell'head
 * (snippets/andpow-colsSwitchHead.liquid) la rilegge al caricamento e la scrive
 * sull'elemento html come data-acs-d/t/m prima che la griglia venga disegnata;
 * qui si gestiscono i click e lo stato dei pulsanti.
 *
 * Ogni selettore sta dentro un contenitore [data-acs-scope] che porta i predefiniti
 * della section (--acs-d, --acs-t, --acs-m) e la griglia .acs-grid. Il listener è
 * delegato su document: vale anche per le griglie che arrivano dai filtri della
 * collezione (evento acf:updated) e da "Mostra altri".
 */
(function () {
  var root = document.documentElement;
  var KEY = 'andpow-cols:' + location.pathname;
  var VIEWPORTS = ['d', 't', 'm'];

  function read() {
    try {
      return JSON.parse(localStorage.getItem(KEY) || '{}') || {};
    } catch (e) {
      return {};
    }
  }

  function save(vp, n) {
    var saved = read();
    saved[vp] = n;
    try {
      localStorage.setItem(KEY, JSON.stringify(saved));
    } catch (e) {}
  }

  // Colonne di un contenitore per un formato: la scelta dell'utente, o il predefinito della section.
  function columns(scope, vp) {
    return root.getAttribute('data-acs-' + vp) || getComputedStyle(scope).getPropertyValue('--acs-' + vp).trim();
  }

  function syncButtons() {
    document.querySelectorAll('[data-acs-scope] [data-acs-n]').forEach(function (btn) {
      var scope = btn.closest('[data-acs-scope]');
      var pressed = columns(scope, btn.getAttribute('data-acs-vp')) === btn.getAttribute('data-acs-n');
      btn.setAttribute('aria-pressed', pressed ? 'true' : 'false');
    });
  }

  // Le immagini dei box hanno srcset: sizes segue le colonne, così il browser sceglie la variante giusta.
  function syncSizes() {
    document.querySelectorAll('[data-acs-scope]').forEach(function (scope) {
      var images = scope.querySelectorAll('img[data-acs-sizes]');
      if (!images.length) return;
      var sizes = '(min-width: 1008px) calc(100vw / ' + columns(scope, 'd') + '), ' +
        '(min-width: 641px) calc(100vw / ' + columns(scope, 't') + '), ' +
        'calc(100vw / ' + columns(scope, 'm') + ')';
      images.forEach(function (img) {
        if (img.getAttribute('sizes') !== sizes) img.setAttribute('sizes', sizes);
      });
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-acs-n]');
    if (!btn || !btn.closest('[data-acs-scope]')) return;
    var vp = btn.getAttribute('data-acs-vp');
    var n = btn.getAttribute('data-acs-n');
    if (VIEWPORTS.indexOf(vp) === -1) return;
    root.setAttribute('data-acs-' + vp, n);
    save(vp, parseInt(n, 10));
    syncButtons();
    syncSizes();
    // lazysizes ricalcola data-sizes="auto" delle card della collezione al resize.
    window.dispatchEvent(new Event('resize'));
  });

  document.addEventListener('acf:updated', function () {
    syncButtons();
    syncSizes();
  });

  syncButtons();
  syncSizes();
})();
